<button type="button" class="rana-gear" *ngIf="visible" (click)="toggle()" [attr.aria-expanded]="open"
        aria-label="Change site colours" title="Site colours">
    <!-- inline SVG: does not depend on the site's icon font having a matching glyph -->
    <svg class="rana-gear-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
         stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <circle cx="12" cy="12" r="3"></circle>
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33h0a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51h0a1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82v0a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
    </svg>
</button>

<div class="rana-gear-panel" *ngIf="open && visible" role="dialog" aria-label="Site colours">
    <div class="rana-gear-head">
        <strong>Site colours</strong>
        <button type="button" class="rana-gear-close" (click)="close()" aria-label="Close">&times;</button>
    </div>

    <div class="rana-gear-group">
        <div class="rana-gear-label">Menu &amp; header</div>
        <div class="rana-gear-swatches">
            <button type="button" *ngFor="let m of menuColors" class="rana-swatch"
                    [class.active]="choice.menu === m.id" [style.background]="swatchBackground(m)"
                    [attr.aria-label]="m.label" [title]="m.label" (click)="pickMenu(m.id)"></button>
        </div>
    </div>

    <div class="rana-gear-group">
        <div class="rana-gear-label">Highlight colour</div>
        <div class="rana-gear-swatches">
            <button type="button" *ngFor="let a of accentColors" class="rana-swatch"
                    [class.active]="choice.accent === a.id" [style.background]="a.value"
                    [attr.aria-label]="a.label" [title]="a.label" (click)="pickAccent(a.id)"></button>
        </div>
    </div>

    <div class="rana-gear-group">
        <div class="rana-gear-label">Screen title</div>
        <div class="rana-gear-chips">
            <button type="button" *ngFor="let t of titleColors" class="rana-chip"
                    [class.active]="choice.title === t.id" (click)="pickTitle(t.id)">{{ t.label }}</button>
        </div>
    </div>

    <button type="button" class="rana-gear-reset" (click)="reset()">Reset to default</button>
    <p class="rana-gear-note">Saved to your account, so it follows you to any browser.</p>
</div>
